import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$1 = ".TOTPEnrollManualScreen_module_codeContainer__dc7a0e56{cursor:pointer}.TOTPEnrollManualScreen_module_code__dc7a0e56{column-gap:1ch;display:grid;grid-template-columns:repeat(var(--st-column-count,auto-fill),var(--st-chunk-size,4ch));justify-content:center}";
collectCss(css$1);
var modules_f9925f51 = {"codeContainer":"TOTPEnrollManualScreen_module_codeContainer__dc7a0e56","code":"TOTPEnrollManualScreen_module_code__dc7a0e56"};

export { css$1 as css, modules_f9925f51 as default };
//# sourceMappingURL=TOTPEnrollManualScreen.module.css.mjs.map
